import { defineStore } from 'pinia'

const postprocessMessage = (message) => {
  if (message.author.avatar) {
    const u = new URL(message.author.avatar);
    u.protocol = window.location.protocol;
    u.host = window.location.host;
    message.author.avatar = u.toString();
  }

  return message;
}

export const useShoutStore = defineStore('shout', {
  state: () => ({
    messages: [],
    channel: { state: '' },
    last: null,
    joined: false
  }),
  actions: {
    initializeShout (socket) {
      const channel = socket.channel('chat:public')
      channel.joinPush.receive('ok', () => {
        this.joined = true
      })
      channel.onClose(() => {
        this.joined = false
      })
      channel.onError(() => {
        this.joined = false
      })
      channel.on('new_msg', (msg) => {
        msg = postprocessMessage(msg)
        this.messages.push(msg)
        this.messages = this.messages.slice(-19, 20)
      })
      channel.on('messages', ({ messages }) => {
        messages = messages.map(postprocessMessage)
        this.messages = messages.slice(-19, 20)
      })
      channel.join()
      this.channel = channel
    }
  }
})
